export const RESERVED_SLUGS = new Set<string>([
  'app',
  'admin',
  'api',
  'p',
  'qr',
  'login',
  'logout',
  'signup',
  'register',
  'static',
  'assets',
  'public',
  'favicon.ico',
  'robots.txt',
  'sitemap.xml',
  'health',
  'healthz',
  'status',
  'about',
  'pricing',
  'terms',
  'privacy',
  'docs',
  'blog',
  'help',
  'support',
  'contact',
  'settings',
  'dashboard',
  'account',
  'me',
]);

export const ROLES = [
  'super_admin',
  'admin',
  'org_owner',
  'org_admin',
  'member',
  'viewer',
] as const;

export const REDIRECT_STATUSES = [301, 302, 307, 308] as const;

export const SHORT_CODE_ALPHABET =
  'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';

export const MAX_TAG_LENGTH = 32;
export const MAX_TITLE_LENGTH = 200;
export const MAX_DESCRIPTION_LENGTH = 2000;
export const MAX_TAGS = 20;
export const MAX_DESTINATION_URL_LENGTH = 2048;
export const MAX_ALIAS_LENGTH = 64;
export const MIN_ALIAS_LENGTH = 3;
